module.exports = __webpack_public_path__ + "static/094_piotra_skargi_anagl-73ff048c65fd3af3a2c9aad6aa501201.jpg";